import { DateOrTimeView } from "@mui/x-date-pickers";
import {
  CheckboxIcon,
  InputIcon,
  PictureIcon,
  RadioIcon,
  SignatureIcon,
  SubTitleIcon,
  TextIcon,
  TitleIcon,
  VideoIcon,
} from "./Icons";

export const IconMap: any = {
  title: TitleIcon,
  subtitle: SubTitleIcon,
  text: TextIcon,
  checkbox: CheckboxIcon,
  signature: SignatureIcon,
  picture: PictureIcon,
  input: InputIcon,
  radio: RadioIcon,
  video: VideoIcon,
};

export const ConsentLabelMap: any = {
  title: "BUILDER_UI.BLOCK_TYPE_TITLE",
  subtitle: "BUILDER_UI.BLOCK_TYPE_SUB_TITLE",
  text: "BUILDER_UI.BLOCK_TYPE_TEXT",
  checkbox: "BUILDER_UI.BLOCK_TYPE_CHECKBOX",
  signature: "BUILDER_UI.BLOCK_TYPE_SIGNATURE",
  picture: "BUILDER_UI.BLOCK_TYPE_PICTURE",
  input: "BUILDER_UI.BLOCK_TYPE_INPUT",
  radio: "BUILDER_UI.BLOCK_TYPE_MULTIPLE_CHOICE",
  video: "BUILDER_UI.BLOCK_TYPE_VIDEO",
};

export const blockTypes = [
  {
    key: "1",
    titleKey: "BUILDER_UI.BLOCK_TYPE_TITLE",
    type: "title",
    icon: IconMap["title"],
  },
  {
    key: "2",
    titleKey: "BUILDER_UI.BLOCK_TYPE_SUB_TITLE",
    type: "subtitle",
    icon: IconMap["subtitle"],
  },
  {
    key: "3",
    titleKey: "BUILDER_UI.BLOCK_TYPE_TEXT",
    type: "text",
    icon: IconMap["text"],
  },
  {
    key: "4",
    titleKey: "BUILDER_UI.BLOCK_TYPE_CHECKBOX",
    type: "checkbox",
    icon: IconMap["checkbox"],
  },
  {
    key: "5",
    titleKey: "BUILDER_UI.BLOCK_TYPE_SIGNATURE",
    type: "signature",
    icon: IconMap["signature"],
  },
  {
    key: "6",
    titleKey: "BUILDER_UI.BLOCK_TYPE_PICTURE",
    type: "picture",
    icon: IconMap["picture"],
  },
  {
    key: "7",
    titleKey: "BUILDER_UI.BLOCK_TYPE_INPUT",
    type: "input",
    icon: IconMap["input"],
  },
  {
    key: "8",
    titleKey: "BUILDER_UI.BLOCK_TYPE_MULTIPLE_CHOICE",
    type: "radio",
    icon: IconMap["radio"],
  },
  {
    key: "9",
    titleKey: "BUILDER_UI.BLOCK_TYPE_VIDEO",
    type: "video",
    icon: IconMap["video"],
  },
];
export const luxonFormats: Record<string, string> = {
  "DD/MM/YYYY": "dd/MM/yyyy",
  "MM/DD/YYYY": "MM/dd/yyyy",
  "DD/MM/YYYY HH:mm": "dd/MM/yyyy HH:mm",
  "MM/DD/YYYY HH:mm": "MM/dd/yyyy HH:mm",
};

export const luxonViews: Record<string, DateOrTimeView[]> = {
  "DD/MM/YYYY": ["day", "month", "year"],
  "MM/DD/YYYY": ["day", "month", "year"],
  "DD/MM/YYYY HH:mm": ["day", "month", "year", "hours", "minutes"],
  "MM/DD/YYYY HH:mm": ["day", "month", "year", "hours", "minutes"],
};

const basicField = {
  label: "",
};
const checkboxField = {
  ...basicField,
  config: {
    optional: true,
    displayType: "checkbox",
  },
};
const signatureField = {
  ...basicField,
  config: {
    name: false,
    address: false,
    date: false,
    optional: false,
    readonly: false,
  },
};
const pictureField = {
  label: "",
  resourceUrl: "",
  config: {
    position: "left",
  },
};

const textField = {
  ...basicField,
};

const inputField = {
  ...basicField,
  config: {
    optional: false,
    type: "text",
    position: "top",
    allowMultiline: false,
  },
};
const radioField = {
  ...basicField,
  config: {
    choices: [{ key: "", label: "" }],
  },
};
const videoField = {
  label: "",
  resourceUrl: "",
};

export const consentFieldMap = (type: string) => {
  switch (type) {
    case "title":
      return textField;
    case "subtitle":
      return textField;
    case "checkbox":
      return checkboxField;
    case "text":
      return textField;
    case "signature":
      return signatureField;
    case "picture":
      return pictureField;
    case "input":
      return inputField;
    case "radio":
      return radioField;
    case "video":
      return videoField;
    default:
      return {};
  }
};
